import CircularProgressbar from 'Components/CircularProgressbar'
import React from 'react'
import { instance } from 'Services/instance'

interface IProps {
    url: string
    alt?: any
    className?: string
    style?: any
    id?: any
    title?: any
}

const VisitImage = (props: IProps) => {
    const [loading, setLoading] = React.useState<boolean>(true);
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [image, setImage] = React.useState<any>(undefined);

    React.useEffect(() => {
        if (!String(props.url).endsWith("?"))
            loadData();
    }, [props.url])

    const loadData = async () => {
        await instance.get(props.url, { timeout: 60000 })
            .then((res) => {
                if (res.status === 200) {
                    setImage(`data:image/png;base64,${res.data}`)
                    // setImage(res.data)
                    setLoading(false)
                    setLoaded(true)
                }
            })
            .catch((error) => {
                setLoading(false)
                console.error(error)
            })
    }

    return (
        <React.Fragment>
            {loading ?
                <img id={props.id}
                    title={props.title}
                    src={image}
                    alt={props.alt}
                    style={props.style}
                    className={`Image${props.className ? props.className.padStart(props.className.length + 1) : ''}`} />
                :
                <CircularProgressbar color="inherit" />
            }
        </React.Fragment>
    )
}

export default VisitImage